import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileuploadComponent } from './fileupload/fileupload.component';
import {PatientUploadService} from "./shared/services/patient.upload.service";
import {UiJpatsModule} from "../shared/ui-jpats/ui-jpats.module";

@NgModule({
  imports: [
    UiJpatsModule,
    CommonModule,
  ],
  declarations: [FileuploadComponent],
  providers: [PatientUploadService],
})
export class ImportsModule { }
